
interface ISingletons {
    [key: string]: any;
}

const singletons:ISingletons = {};

export const singleton = <T>(key: string, create: () => T): T => {
    singletons[key] = singletons[key] || create();
    return singletons[key] as T;
};

export const singletonExists = (key: string): boolean => singletons[key];

